import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/subscription'
import pathMap from 'src/paths/PathMap_AccountSetup'

class SubscriptionRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.SUBSCRIPTION_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.SUBSCRIPTION_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.SUBSCRIPTION_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.SUBSCRIPTION_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default SubscriptionRoute
